import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=c4c5c4c4&scoped=true&"
import script from "./refuse.vue?vue&type=script&lang=js&"
export * from "./refuse.vue?vue&type=script&lang=js&"
import style0 from "./refuse.vue?vue&type=style&index=0&id=c4c5c4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c5c4c4",
  null
  
)

export default component.exports